// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__J2i7R","itemTitle":"ClientEmergencyInfo_itemTitle__1i0HY","itemText":"ClientEmergencyInfo_itemText__2Ys7M"};